module.exports = __webpack_public_path__ + "media/sapa_archive/SAPAbg620x180-d12af454.gif";